import { CircleHelpIcon } from '@persona-id/design-tokens/icons';
import { ReactNode } from 'react';

import NavBack from 'dashboard/components/NavBack';
import { Header } from 'dashboard/layouts/IndexViewLayoutV2';
import { Paragraph } from 'design-system/components/Text';
import Tooltip from 'design-system/components/Tooltip';

export interface ExternalIntegrationHeaderProps {
  editable: boolean;
  children: ReactNode;
}

const ExternalIntegrationHeader = ({ editable, children }: ExternalIntegrationHeaderProps) => {
  return (
    <Header
      title='Marketplace'
      level='detail'
      // TODO: (Ariel) Both the Marketplace and Integrations routes lead to this page, so the back button should navigate to the previous route from which the user arrived.
      prepend={<NavBack to='/dashboard/integrations' aria-label='Back to integrations' />}
    >
      {children}
      {!editable && (
        <Tooltip side='right' iconTrigger={<CircleHelpIcon />} aria-label='tool tip'>
          <Paragraph>Your user role does not have permission to add connections.</Paragraph>
        </Tooltip>
      )}
    </Header>
  );
};

export default ExternalIntegrationHeader;
